var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangleAdmiration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.76672V13.5167",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2942 3.76672L21.5441 18.0167C21.6756 18.2444 21.7449 18.5025 21.7451 18.7654C21.7453 19.0283 21.6765 19.2866 21.5455 19.5144C21.4144 19.7423 21.2258 19.9317 20.9985 20.0638C20.7713 20.1958 20.5133 20.2658 20.2504 20.2667H3.7504C3.48754 20.2658 3.22954 20.1958 3.00225 20.0638C2.77496 19.9317 2.58635 19.7423 2.45532 19.5144C2.3243 19.2866 2.25545 19.0283 2.25568 18.7654C2.25592 18.5025 2.32522 18.2444 2.45665 18.0167L10.7066 3.76672C10.8371 3.53878 11.0254 3.34935 11.2526 3.21761C11.4798 3.08586 11.7378 3.01648 12.0004 3.01648C12.263 3.01648 12.521 3.08586 12.7482 3.21761C12.9754 3.34935 13.1637 3.53878 13.2942 3.76672V3.76672Z",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.8292C11.4822 17.8292 11.0625 17.4095 11.0625 16.8917C11.0625 16.374 11.4822 15.9542 12 15.9542C12.5178 15.9542 12.9375 16.374 12.9375 16.8917C12.9375 17.4095 12.5178 17.8292 12 17.8292Z",
    fill: "#2C3B60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleAdmiration);
export default __webpack_public_path__ + "static/media/TriangleAdmiration.f6e944d6fda64165c6dbfbafaaa876fe.svg";
export { ForwardRef as ReactComponent };